import { Component, inject } from '@angular/core';
import { SoilStratumTypeService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SoilStratumTypeCreateDto,
  SoilStratumTypeDto,
  SoilStratumTypeExcelDownloadDto,
  SoilStratumTypeUpdateDto,
} from '../proxy/planning/dtos/soil-stratum-type';
import { SOILSTRATUMTYPE_CONFIG, SOILSTRATUMTYPE_FIELDS } from './soil-stratum-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-soil-stratum-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SoilStratumTypeService, ConfirmationService],
  templateUrl: './soil-stratum-type.html',
  styleUrl: './soil-stratum-type.scss',
})
export class SoilStratumType extends BaseCrudComponent<
  SoilStratumTypeDto,
  SoilStratumTypeCreateDto,
  SoilStratumTypeUpdateDto,
  SoilStratumTypeExcelDownloadDto
> {
  service = inject(SoilStratumTypeService);
  config = SOILSTRATUMTYPE_CONFIG;
  fields = SOILSTRATUMTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: SoilStratumTypeDto): SoilStratumTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SoilStratumType';
  }
}
